import * as v from 'valibot';
import { DataService } from '../services/data_service';
import { EntryComponentConfig, Envelope } from '../shared/types/common.model';
import { SkillAssociatedWithCourse, SkillAssociatedWithCourseSchema } from '../shared/types/skills.model';
import { ClientRequestHandler } from './client-request-handler';

export class SkillsClient extends ClientRequestHandler {
  private dataService: DataService;
  private readonly API_VERSION = '/api/v2';

  constructor(internalConfig: EntryComponentConfig) {
    super('SkillsClientError');
    this.dataService = DataService.getInstance(internalConfig.baseUrl);
  }

  async getSkillsAssociatedWithCourse(courseGuid: string, signal?: AbortSignal): Promise<SkillAssociatedWithCourse[]> {
    const request = this.dataService.get<Envelope<Array<SkillAssociatedWithCourse>>>(
      `${this.API_VERSION}/skills/courses/${courseGuid}/assignments?page=1&page_size=500`,
      signal
    );

    return this.handleRequest<Array<SkillAssociatedWithCourse>>(request, v.array(SkillAssociatedWithCourseSchema));
  }
}
